// base url for files
export const BASEURL1 = process.env.REACT_APP_MIGRATION_BASE_URL

// base url for apis
export const BASEURL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL + 'v1/' : process.env.REACT_APP_BASE_URL_DEV

// base url for migration apis
export const MIGRATION_URL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_MIGRATION_BASE_URL : process.env.REACT_APP_MIGRATION_BASE_URL_DEV
